import "./CircleSVGAnimated.scss";

const CircleSVGAnimated = () => {
  const d = new Date();
  let year = d.getFullYear();

  return (
    // <svg viewBox="0 0 500 500" className="text-svg">
    //   <defs>
    //     <path
    //       d="M250 400a150 150 0 010-300 150 150 0 010 300z"
    //       transform="rotate(12 250 250)"
    //     ></path>
    //   </defs>
    //   <rect width="100%" height="100%" fill="none"></rect>
    //   <text>
    //     <textPath> Portfolio • Portfolio • Portfolio • </textPath>
    //   </text>
    // </svg>

    <div className="CircleBadge">
      <svg viewBox="0 0 500 500">
        <path
          id="curve"
          fill="transparent"
          d="M0,250a250,250 0 1,0 500,0a250,250 0 1,0 -500,0"
        />
        <text width="500">
          <textPath xlinkHref="#curve">
            Portfolio • {year} • Portfolio • {year} • Portfolio •
            {year} • Portfolio • {year} • Portfolio •
          </textPath>
        </text>
      </svg>

      <div className="center-text">Selected Works</div>
    </div>
  );
};

export default CircleSVGAnimated;
